import { createAction, props } from '@ngrx/store';
import { SidebarItemModel } from '../../models/sidebar-item.model';

export const loadSidebar = createAction(
  '[Sidebar] Load Sidebar'
);

export const loadSidebarSuccess = createAction(
  '[Sidebar] Load Sidebar Success',
  props<{ items: SidebarItemModel[] }>()
);
